import React from "react";
import { array } from "prop-types";

import CustomStoryCard4 from "../../../../molecules/CustomStoryCard4";

import "./organism2.m.css";

const Organism2 = ({ stories }) =>
  stories.length > 0 && (
    <div styleName="base">
      {stories.map(({ story }, index) => (
        <CustomStoryCard4
          story={story}
          key={index}
          headlineType={37}
          showStoryMetaInfo={true}
          updatedFont={true}
          src="big-fact-org2"
        />
      ))}
    </div>
  );

Organism2.propTypes = {
  stories: array.isRequired
};

export default Organism2;
